var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42069 14.0977C1.58319 13.5469 1.88124 13.043 2.28788 12.6367L14.168 0.754702C15.1445 -0.221782 16.7305 -0.221782 17.707 0.754702L19.2461 2.29494C19.3672 2.41681 19.4726 2.54845 19.5664 2.68712C20.207 3.65744 20.1016 4.97658 19.2461 5.83205L7.36327 17.711C7.31249 17.7617 7.26171 17.7774 7.20702 17.8594C6.83202 18.1914 6.38671 18.4024 5.90234 18.5781L1.20194 19.961C0.873038 20.0586 0.517179 19.9688 0.274601 19.6914C0.0320146 19.4844 -0.0586807 19.1289 0.0381161 18.7969L1.42069 14.0977ZM2.32187 17.6797L5.37499 16.7813C5.46484 16.7539 5.55468 16.6836 5.64062 16.6758L4.22265 16.3906C3.91405 16.3281 3.67069 16.086 3.60898 15.7774L3.32538 14.3594C3.28202 14.4453 3.24648 14.5352 3.21952 14.625L2.32187 17.6797ZM7.05858 15.3633L14.9609 7.46095L12.5039 5.00392L4.63671 12.9414L5.0039 14.961L7.05858 15.3633Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b3c52221f535f3cbec7947124b42b768.svg";
export { ForwardRef as ReactComponent };